import { COMPANY_ADDRESS_FULL, COMPANY_LOCATION, COMPANY_REGION, FILED_DATE, MAP_URL } from '../constants';

function VisitSection() {
  return (
    <section id="visit" className="relative overflow-hidden bg-midnight text-paper">
      <div className="relative mx-auto grid max-w-6xl gap-12 px-6 py-20 lg:grid-cols-[0.92fr_1.08fr] lg:items-center">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.22em] text-signal">
            Principal office
          </p>
          <h2 className="mt-3 text-4xl font-black uppercase tracking-normal text-paper sm:text-5xl">
            {COMPANY_LOCATION}
          </h2>
          <p className="mt-5 max-w-md leading-8 text-paper/70">
            Use the address below for directory listings, public correspondence, and location context. The profile is based on the {COMPANY_REGION} filing dated {FILED_DATE}.
          </p>
        </div>

        <div className="relative rounded-2xl border border-paper/20 bg-paper/10 p-8 backdrop-blur">
          <div className="absolute -top-4 left-8 inline-flex items-center gap-2 rounded-pill bg-signal px-4 py-1.5 text-[11px] font-black uppercase tracking-[0.2em] text-midnight">
            Public address
          </div>
          <p className="mt-3 text-3xl font-black uppercase leading-snug text-paper sm:text-4xl">
            {COMPANY_ADDRESS_FULL}
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href={MAP_URL}
              target="_blank"
              rel="noreferrer"
              className="rounded-pill bg-signal px-6 py-3 text-center font-black text-midnight transition hover:bg-mint"
            >
              Open in Google Maps
            </a>
            <a
              href="#top"
              className="rounded-pill border border-paper/30 px-6 py-3 text-center font-semibold text-paper transition hover:bg-paper/10"
            >
              Back to top
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VisitSection;
